import { get } from 'lodash';
import React, { FC } from 'react';
import { ABSCHLUSS_HINWEISE_TABS } from 'src/lib/constants/constant';
import AbschlussWeitere from '../../../../global-structure/abschluss-seite/content/AbschlussWeitere';
import MAAngabenPruefen from './MAAngabenPruefen';
import MAEinreichen from './MAEinreichen';
import MAHerunterladen from './MAHerunterladen';

const GetAbschlussContentMA: FC<{ hinweis: any; paths: any }> = ({ hinweis, paths }) => {
	const untertitel = get(hinweis, paths.UnterTitel, '');
	const tab = get(hinweis, paths.Tab, '');
	const inhalt = get(hinweis, paths.Inhalt, '');
	switch (tab) {
		case ABSCHLUSS_HINWEISE_TABS.AngabenPruefen:
			return <MAAngabenPruefen untertitel={untertitel} inhalt={inhalt} />;
		case ABSCHLUSS_HINWEISE_TABS.AntragHerunterladen:
			return <MAHerunterladen untertitel={untertitel} inhalt={inhalt} />;
		case ABSCHLUSS_HINWEISE_TABS.FoerderungBeantragen:
			return <MAEinreichen untertitel={untertitel} inhalt={inhalt} />;
		default:
			return <AbschlussWeitere untertitel={untertitel} inhalt={inhalt} />;
	}
};

export default GetAbschlussContentMA;
